<template>
    <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="1"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <div class="i-form">
            <h3 class="h-title">业务进展情况</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>当前状态</th>
                    <td><span :style="{color:detailData.status == '2'||detailData.status == '4'?'#B82121':'#42AE0E'}">{{stateFormat(detailData.status)}}</span></td>         
                </tr>
                <tr>
                    <th>审核意见</th>
                    <td>{{exList.auditContent || '--'}}</td>         
                </tr>
                <tr>
                    <th>HASH值</th>
                    <td>{{detailData.blockchainHash}}</td>         
                </tr>
            </table>
        </div>
        <div class="i-form">
            <h3 class="h-title">供应链服务详情</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>单方用章协议</th>
                    <td ><span class="file-link" v-if="detailData.unitSealProtocolFile[0]" @click="downloadFile(detailData.unitSealProtocolFile[0].url)">{{detailData.unitSealProtocolFile[0].name}}</span></td>         
                </tr>
                <tr>
                    <th>选择律所</th>
                    <td>{{detailData.lawFirmName}}</td>
                </tr>
                <tr>
                    <th>权威节点</th>
                    <td>{{nodeFormat(detailData.authorityNode)}}</td>
                </tr>
                <tr>
                    <th>存储类型</th>
                    <td>{{typeFormat(detailData.saveType)}}</td>
                </tr>
                <tr>
                    <th>主合同名称</th>
                    <td>{{detailData.mainContractName}}</td>
                </tr>
                <tr>
                    <th>主合同编号</th>
                    <td>{{detailData.mainContractNo}}</td>
                </tr>
                <tr>
                    <th>主合同期限</th>
                    <td >{{detailData.mainContractPeriodStart}}-{{detailData.mainContractPeriodEnd}}</td>
                </tr>
                <tr>
                    <th>主合同金额</th>
                    <td>{{setComdify(detailData.mainContractAmount,4)}} 万元</td>
                </tr>
                <tr>
                    <th>共识金额</th>
                    <td>{{setComdify(detailData.consensusAmount,4)}} 万元</td>
                </tr>
                <tbody v-for="item in 10" :key="'main'+item">
                    <tr v-if="detailData['mainContractSignName'+item]">
                        <th>主合同签约主体{{item}}名称</th>
                        <td >{{detailData['mainContractSignName'+item]}}</td>
                    </tr>
                </tbody>
                
                <tr v-if="detailData.subContractName">
                    <th>从合同名称</th>
                    <td> {{detailData.subContractName}}</td>
                </tr>
                <tr v-if="detailData.subContractName">
                    <th>从合同编号</th>
                    <td>{{detailData.subContractNo}}</td>
                </tr>
                <tr v-if="detailData.subContractName">
                    <th>从合同期限</th>
                    <td >{{detailData.subContractPeriodStart}}-{{detailData.subContractPeriodEnd}}</td>
                </tr>
                <tr v-if="detailData.subContractName">
                    <th>从合同金额</th>
                    <td >{{setComdify(detailData.subContractAmount,4)}} 万元</td>
                </tr>
                <tbody v-for="item in 10" :key="'sub'+item">
                    <tr v-if="detailData['subContractSignName'+item]">
                        <th>从合同签约主体{{item}}名称</th>
                        <td >{{detailData['subContractSignName'+item]}}</td>
                    </tr>
                </tbody>
                
                <tr>
                    <th>三证合一</th>
                    <td ><span class="file-link" v-if="detailData.threeCertOneFile[0]" @click="downloadFile(detailData.threeCertOneFile[0].url)">{{detailData.threeCertOneFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>法定代表人身份证</th>
                    <td ><span class="file-link" v-if="detailData.identityCardFile[0]" @click="downloadFile(detailData.identityCardFile[0].url)">{{detailData.identityCardFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>公司简介</th>
                    <td ><span class="file-link" v-if="detailData.companyProfileFile[0]" @click="downloadFile(detailData.companyProfileFile[0].url)">{{detailData.companyProfileFile[0].name}}</span></td>
                </tr>  

                <tr>
                    <th>公司简章</th>
                    <td ><span class="file-link" v-if="detailData.companyByelawFile[0]" @click="downloadFile(detailData.companyByelawFile[0].url)">{{detailData.companyByelawFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>高管人员简历</th>
                    <td ><span class="file-link" v-if="detailData.ggPersonResumeFile[0]" @click="downloadFile(detailData.ggPersonResumeFile[0].url)">{{detailData.ggPersonResumeFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>近两年财务报表及最近一期财务报表</th>
                    <td ><span class="file-link" v-if="detailData.financeReportFile[0]" @click="downloadFile(detailData.financeReportFile[0].url)">{{detailData.financeReportFile[0].name}}</span></td>
                </tr>  
                <!-- <tr>
                    <th>共识智库（灰名单查询）：</th>
                    <td ><span class="file-link" v-if="detailData.riskResultFile[0]" @click="downloadFile(detailData.riskResultFile[0].url)">{{detailData.riskResultFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>共识智库（智库报告）：</th>
                    <td ><span class="file-link" v-if="detailData.thinktankReportFile[0]" @click="downloadFile(detailData.thinktankReportFile[0].url)">{{detailData.thinktankReportFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>DR Airating：</th>
                    <td ><span class="file-link" v-if="detailData.creditReportFile[0]" @click="downloadFile(detailData.creditReportFile[0].url)">{{detailData.creditReportFile[0].name}}</span></td>
                </tr>   -->
                <tr>
                    <th>供应链服务协议</th>
                    <td ><span class="file-link" v-if="detailData.serviceProtocolFile[0]" @click="downloadFile(detailData.serviceProtocolFile[0].url)">{{detailData.serviceProtocolFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>供应链服务申请书</th>
                    <td ><span class="file-link" v-if="detailData.serviceApplyFile[0]" @click="downloadFile(detailData.serviceApplyFile[0].url)">{{detailData.serviceApplyFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>供应链申请人承诺书</th>
                    <td ><span class="file-link" v-if="detailData.serviceApplyConfirmFile[0]" @click="downloadFile(detailData.serviceApplyConfirmFile[0].url)">{{detailData.serviceApplyConfirmFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>拟存储文件</th>
                    <td ><span class="file-link" v-if="detailData.planSaveFile[0]" @click="downloadFile(detailData.planSaveFile[0].url)">{{detailData.planSaveFile[0].name}}</span></td>
                </tr>    
            </table>
        </div>
    </el-main>
  </el-container>
</template>
<script>
    import leftMenu from './components/leftMenu'
	export default {
		name: "CDetail",
        components: {
            leftMenu
        },
		data() {
			return {
                setComdify: this.comdify,
				detailData: {},
				id: null,
				taskKey: '',
				taskId: '',
				exList: {},	
                typeOptions: [],
                stateOptions: [],
			}
    },
    created() {
        window.scrollTo(0,0);
        this.id = this.$route.query.id;
        this.$api.api.getDicts("gyl_state").then(response => {
            this.stateOptions = response.data;
        });
        this.$api.api.getDicts("save_type").then(response => {
            this.typeOptions = response.data;
        });
    },
    mounted() {
        this.getDetial();	
	},
    methods: {
        downloadFile(url){
            this.$api.api.downloadFile(url)
        },
        selectDictLabel(datas, value) {
            var actions = [];
            Object.keys(datas).some((key) => {
                if (datas[key].dictValue == ('' + value)) {
                    actions.push(datas[key].dictLabel);
                    return true;
                }
            })
            return actions.join('');
        }, 
        nodeFormat(val){
            if(val){
                let arr = JSON.parse(val)
                let nodeName = []
                arr.forEach(item => {
                    nodeName.push(item.name)
                })
                return nodeName.join('，')
            }else {
                return ''
            }
            
        },
        typeFormat (val) {
            return this.selectDictLabel(this.typeOptions, val);
        }, 
        stateFormat (val) {
            return this.selectDictLabel(this.stateOptions, val);
        }, 
        //获取详情
        getDetial() {
            this.$api.api.contractDetail(this.id).then(res => {
                this.listLoading = false;
                if(res.code==200){
                    this.detailData = Object.assign({}, res.data); 	
                    this.detailData.unitSealProtocolFile = JSON.parse(this.detailData.unitSealProtocolFile || '[]');
                    this.detailData.threeCertOneFile = JSON.parse(this.detailData.threeCertOneFile || '[]');
                    this.detailData.identityCardFile = JSON.parse(this.detailData.identityCardFile || '[]');
                    this.detailData.companyProfileFile = JSON.parse(this.detailData.companyProfileFile || '[]');
                    this.detailData.companyByelawFile = JSON.parse(this.detailData.companyByelawFile || '[]');
                    this.detailData.ggPersonResumeFile = JSON.parse(this.detailData.ggPersonResumeFile || '[]');
                    this.detailData.financeReportFile = JSON.parse(this.detailData.financeReportFile || '[]');
                    // this.detailData.riskResultFile = JSON.parse(this.detailData.riskResultFile || '[]');
                    // this.detailData.thinktankReportFile = JSON.parse(this.detailData.thinktankReportFile || '[]');
                    // this.detailData.creditReportFile = JSON.parse(this.detailData.creditReportFile || '[]');
                    this.detailData.serviceProtocolFile = JSON.parse(this.detailData.serviceProtocolFile || '[]');
                    this.detailData.serviceApplyFile = JSON.parse(this.detailData.serviceApplyFile || '[]');
                    this.detailData.serviceApplyConfirmFile = JSON.parse(this.detailData.serviceApplyConfirmFile || '[]');
                    this.detailData.planSaveFile = JSON.parse(this.detailData.planSaveFile || '[]');
                    this.exList = res.data.contractProjectAuditList[0] || {}
                }else {
                    this.$message.error(res.msg);
                }    
            });      
        },
    }
}
</script>

<style lang="less">
@import '../style.less';
</style>